import type { FeatureLike } from "ol/Feature";
import type MapBrowserEvent from "ol/MapBrowserEvent";
import type { Coordinate } from "ol/coordinate";
import type { Pixel } from "ol/pixel";

export type OlMapPointerEventType =
    | "click"
    | "singleclick"
    | "dblclick"
    | "pointerdown"
    | "pointerup"
    | "pointercancel"
    | "pointermove"
    | "pointerdrag";

export type OlMapKeyboardEventType = "keydown" | "keyup";
export type OlMapContextMenuEventType = "contextmenu";

export type OlMapPointerEventDetail = {
    readonly type: OlMapPointerEventType;
    readonly event: MapBrowserEvent;
    readonly features: readonly FeatureLike[];
    readonly hitTolerance: number;
};

export type OlMapKeyboardEventDetail = {
    readonly type: OlMapKeyboardEventType;
    readonly event: KeyboardEvent;
};

export type OlMapContextMenuEventDetail = {
    readonly type: OlMapContextMenuEventType;
    readonly event: MouseEvent;
    readonly pixel: Pixel;
    readonly coordinate: Coordinate;
    readonly features: readonly FeatureLike[];
    readonly hitTolerance: number;
};

export class OlMapPointerEvent extends Event {
    public readonly detail: OlMapPointerEventDetail;

    public constructor(detail: OlMapPointerEventDetail) {
        super("ol-pointer-event", { bubbles: true, composed: true, cancelable: true });
        this.detail = detail;
    }
}

export class OlMapKeyboardEvent extends Event {
    public readonly detail: OlMapKeyboardEventDetail;

    public constructor(detail: OlMapKeyboardEventDetail) {
        super("ol-keyboard-event", { bubbles: true, composed: true, cancelable: true });
        this.detail = detail;
    }
}

export class OlMapContextMenuEvent extends Event {
    public readonly detail: OlMapContextMenuEventDetail;

    public constructor(detail: OlMapContextMenuEventDetail) {
        super("ol-contextmenu-event", { bubbles: true, composed: true, cancelable: true });
        this.detail = detail;
    }
}
